module.exports = __webpack_public_path__ + "img/solution-pro.d70b51ed.svg";